import { useNavigationType } from "react-router-dom";

export const useNavigationInfo = () => {
  const navigationType = useNavigationType();
  return {
    isBack: navigationType === "POP",
    isForward: navigationType === "PUSH",
  };
};
